import './Infoshare.scss'

import {isFuture} from 'date-fns'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import enLocale from 'date-fns/locale/en-GB'
import esLocale from 'date-fns/locale/es'
import frLocale from 'date-fns/locale/fr'
import nlLocale from 'date-fns/locale/nl'
import React from 'react'
import {dateFromServerDate} from 'util/dates'
import {formatDate} from '../../util/dates'
import {useLanguage, useTranslation} from '../../util/i18n'
import {style} from '../../util/style'
import {Theme} from '../Theme'
import {Share} from './Share'

const styles = style('infoshare')

export type InfoshareType = {
	date: {
		start?: string
		end?: string
	}
	location: {
		no_address?: boolean
		street?: string
		housenumber?: string
		zip?: string
		city?: string
	}
}

export const Infoshare: React.FC<InfoshareType> = ({date, location}) => {
	if (!date && !location) return null
	const t = useTranslation('teams').overview.info
	const {start, end} = date

	const countdownMessage = buildCountdownMessage(start, end)
	return (
		<div className={styles()}>
			<div className={styles('row')}>
				<div className={styles('row-left')}>
					{location?.city && (
						<Theme.H4 className={styles('location')} mod="green">
							{location.city}
						</Theme.H4>
					)}
					{date?.start && (
						<Theme.H3 className={styles('date')} mod="bold">
							{formatDate(date.start, 'EEEE d MMMM yyyy')}
						</Theme.H3>
					)}
				</div>
				<div className={styles('row-right')}>
					<p
						className={styles('countdown')}
						dangerouslySetInnerHTML={{__html: countdownMessage}}
					/>
					<Share text={t.share} />
				</div>
			</div>
		</div>
	)
}

const buildCountdownMessage = (start, end) => {
	const lang = useLanguage()
	const t = useTranslation('events').info_share
	const startDate = dateFromServerDate(start)
	const endDate = dateFromServerDate(end)
	if (!isFuture(endDate)) return null
	const suffix = isFuture(startDate) ? t.action_starts : t.action_endures

	const distanceInWords = getDistanceInWords(
		isFuture(startDate) ? startDate : endDate,
		lang
	)
	return `<p>${suffix} <b>${distanceInWords}</b></p>`
}

const getDistanceInWords = (date, lang) => {
	const locale = switchLocale(lang)
	return formatDistanceToNow(date, {
		addSuffix: false,
		locale
	})
}

const switchLocale = (lang) => {
	switch (lang) {
		case 'nl':
			return nlLocale
		case 'fr':
			return frLocale
		case 'en':
			return enLocale
		case 'es':
			return esLocale
	}
}
